import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  callHistoryActions,
  callHistorySelectors,
  callSelectors,
  chatSelectors,
  currentUserSelectors,
  featureSelectors,
  accountSelectors
} from '@lifesize/nucleus';
import SideNav from 'components/SideNav/SideNav';
import { isCallConnected } from 'utils/call-utils';
import { toggleSideNav } from 'actions/SideNav';
import { upcomingNotificationCountSelector } from 'selectors/calendar';
import { SIDE_NAV_SNAP_THRESHOLD } from 'constants/SideNav';
import { SIDE_NAV_WIDE_SETTING } from 'constants/UserSettings';
import _get from 'lodash/get';
import { selectCurrentPath } from 'selectors/auth';

const mapActionCreators = {
  toggleSideNav: () => toggleSideNav(),
  markCallHistoryAsViewed: () => callHistoryActions.markCallHistoryAsViewed(),
};

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const isCallCon = isCallConnected(activeCall);
  const isSideNavWide = _get(currentUserSelectors.myInfo(state), ['userSettings', SIDE_NAV_WIDE_SETTING]);

  return {
    hideContacts: _get(accountSelectors.getAccountFeatures(state),'hideContacts', false),
    hideMeetings: _get(accountSelectors.getAccountFeatures(state),'hideMeetings', false),
    hideRooms: _get(accountSelectors.getAccountFeatures(state),'hideRooms', false),
    isCallConnected: isCallCon,
    isChatEnabled: featureSelectors.isChatEnabled(state) && accountSelectors.getAccountFeatures(state).isChatEnabled,
    isSideNavWide: isSideNavWide || (isCallCon && _get(state, 'app.inCallVideo.isMinimized')),
    missedCalls: callHistorySelectors.totalNewMissedCalls(state),
    routeLoaded: selectCurrentPath(state),
    snapThreshold: SIDE_NAV_SNAP_THRESHOLD,
    unreadChats: chatSelectors.groupedConversationsWithUnread(state).totalUnreadMessageCount,
    upcomingMeetings: upcomingNotificationCountSelector(state)
  };
};

export default injectIntl(connect(mapStateToProps, mapActionCreators)(SideNav));
